import React, { useRef } from "react";
import MarkIcon from "../../../../assets/SideBar/MarkIcon";
import TaskIcon from "../../../../assets/SideBar/TaskIcon";
import {
  Container,
  Title,
  Draggable,
  ActivityNode,
  IconDiv,
  HiddenElements,
  HiddenIconDiv,
} from "./styles";

const Activities = ({ Label, onDrag }) => {
  const taskIconRef = useRef(null);
  const markIconRef = useRef(null);
  return (
    <Container>
      <Title>{Label}</Title>
      <Draggable>
        <ActivityNode
          style={{ marginRight: "0.125rem" }}
          draggable
          onDragStart={(event) => {
            onDrag(event, "task");
            if (taskIconRef.current) {
              event.dataTransfer.setDragImage(taskIconRef.current, -15, -15);
            }
          }}
        >
          <IconDiv>
            <TaskIcon />
          </IconDiv>
          <span>Tarefa</span>
        </ActivityNode>
        <ActivityNode
          draggable
          onDragStart={(event) => {
            onDrag(event, "customMark");
            if (markIconRef.current) {
              event.dataTransfer.setDragImage(markIconRef.current, -15, -15);
            }
          }}
        >
          <IconDiv>
            <MarkIcon />
          </IconDiv>
          <span>Marcador</span>
        </ActivityNode>
        <HiddenElements>
          <HiddenIconDiv ref={taskIconRef}>
            <TaskIcon />
          </HiddenIconDiv>
          <HiddenIconDiv ref={markIconRef}>
            <MarkIcon />
          </HiddenIconDiv>
        </HiddenElements>
      </Draggable>
    </Container>
  );
};

export default Activities;
